// Exports
export default {
	"status": "status_kvsiw"
};
